import { render, staticRenderFns } from "./CategoryToolServer.vue?vue&type=template&id=66cdd37d&scoped=true&"
import script from "./CategoryToolServer.vue?vue&type=script&lang=js&"
export * from "./CategoryToolServer.vue?vue&type=script&lang=js&"
import style0 from "../assets/v2/css/trans/common.less?vue&type=style&index=0&id=66cdd37d&prod&lang=less&scoped=true&"
import style1 from "./CategoryToolServer.vue?vue&type=style&index=1&id=66cdd37d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cdd37d",
  null
  
)

export default component.exports